export const Claim = {
    path: '/claims',
    name: 'claims',
    component: () => import('@/views/Request/Claim/ClaimPage.vue'),
    children: [
        {
            path: '/claims/add',
            name: 'claims.add',
            component: () => import('@/views/Request/Claim/Form/ClaimForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/claims/edit/:id',
            name: 'claims.edit',
            component: () => import('@/views/Request/Claim/Form/ClaimForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/claims/delete/:id',
            name: 'claims.delete',
            component: () => import('@/views/Request/Claim/Form/ClaimForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/claims/view/:id',
            name: 'claims.view',
            component: () => import('@/views/Request/Claim/Form/ClaimForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/claims/set_decision/:id/:module',
            name: 'claims.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/claims/take_in_charge/:id/:module',
            name: 'claims.take_in_charge',
            component: () => import('@/views/Request/Components/TakeInCharge.vue'),
        },
        {
            path: '/claims/timelines/:id/:module',
            name: 'claims.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines'),
        },
      {
        path: '/claims/documents/:id',
        name: 'claims.documents',
        component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
        props: {module: "CLAIM"}
      },
    ],
}